<template>
  <store-recherche-provider key="titreRecetteCollectivite"
          :name="constantes.storeName"
          :copy="factureAchatARapprocherStore"
          :copyChanges="changesFactureTlpeStore">
    <liste-facture-achat
              :permFactureAchat="permFactureAchat"
              :referenceTable="referenceTable"
              :nameStore="constantes.storeName"
              :moduleDcf="constantes.MODULE_TLPE"
              :isFromTiers="true"
              :extraCritereInit="{tiersId: [collectivite]}"
              :baseTraduction="'listeTitreRecette'" />
  </store-recherche-provider>
</template>

<script>
import factureAchatARapprocherStore from '@/store/modules/baux/factureAchatARapprocher';
import { MODULE_TLPE } from '@/configuration/devisConf';
import listeFactureAchat from '@/components/factures/listeFactureAchat';
import { TITRE_RECETTE_COLLECTIVITE_STORE } from '@/configuration/gabed/tlpe/tlpeConf';
import { TITRE_RECETTE } from '@/configuration/gabed/permissionsGabedConf';
import { REFERENCE_TABLE_TITRE_RECETTE_COLLECTIVITE } from '@/configuration/general/referenceTableConf';
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import genererCritereRechercheTitreRecette from '@/services/gabed/titreRecette/genererCritereRechercheTitreRecette';
import * as allTypes from '@/store/mutation-type';
import {
  SET_CRITERE_RECHERCHE,
} from '@/store/modules/baux/factureAchatARapprocher-mutation-type';

export default {
  props: {
    collectivite: {
      required: true,
      type: Object,
    },
  },
  components: {
    listeFactureAchat,
    storeRechercheProvider,
  },
  data() {
    return {
      referenceTable: REFERENCE_TABLE_TITRE_RECETTE_COLLECTIVITE,
      permFactureAchat: TITRE_RECETTE,
      constantes: {
        MODULE_TLPE,
        storeName: TITRE_RECETTE_COLLECTIVITE_STORE,
      },
      factureAchatARapprocherStore,
    };
  },
  computed: {
    changesFactureTlpeStore() {
      return {
        state: {
          items: [],
          total: 0,
          criteresRecherche: genererCritereRechercheTitreRecette(),
          lastPayload: {},
        },
        mutations: {
          [allTypes.RESET_STATE](state) {
            const s = {
              items: [],
              total: 0,
              criteresRecherche: genererCritereRechercheTitreRecette(),
              lastPayload: {},
            };
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      };
    },
  },
  mounted() {
    this.$store.commit(`${this.constantes.storeName}/${SET_CRITERE_RECHERCHE}`, {
      ...genererCritereRechercheTitreRecette(),
      tiersId: [this.collectivite],
    });
  },
};
</script>
